module.exports = __webpack_public_path__ + "card_view.a206a5ee.png";